// src/features/home/components/ArticleCard.tsx

import React from 'react';
import styles from './ArticleCard.module.scss';

interface ArticleCardProps {
  title: string;
  description: string;
  image?: string;
  url: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({ title, description, image, url }) => {
  return (
    <li className={styles.articleItem}>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.articleCard}
        aria-label={`${title} (opens in a new tab)`}
      >
        <div className={styles.hoverOverlay}></div>
        {image && (
          <div className={styles.imageWrapper}>
            <img src={image} alt={title} />
          </div>
        )}
        <div className={styles.content}>
          <h3 className={styles.title}>
            <span>
              {title}
              <svg
                className={styles.externalLinkIcon}
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5A.75.75 0 0013.25 5h-7.5a.75.75 0 000 1.5h5.69L4.22 13.72a.75.75 0 000 1.06z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
          </h3>
          <p className={styles.description}>{description}</p>
        </div>
      </a>
    </li>
  );
};

export default ArticleCard;